export const ENABLE_SSO_STATUS = 'ENABLE_SSO_STATUS';
